export const lowerDisplayLineTestIDs = {
  city: 'lower_display_line_city',
  logoAndTimeWidget: 'lower_display_line_logo_and_time_widget',
  alertHeadlines: {
    alert1: 'lower_display_line_alert_headlines_alert_one',
    alert2: 'lower_display_line_alert_headlines_alert_two',
    alert3: 'lower_display_line_alert_headlines_alert_three',
    productLabel: 'lower_display_line_alert_headlines_product_label',
  },
  now: {
    feelsLike: 'lower_display_line_now_feels_like',
    gusts: 'lower_display_line_now_gusts',
    humidity: 'lower_display_line_now_humidity',
    productLabel: 'lower_display_line_now_product_label',
    temperature: 'lower_display_line_now_temperature',
    weatherPhrase: 'lower_display_line_now_weather_phrase',
    windDirectionCardinal: 'lower_display_line_now_wind_direction_cardinal',
    windSpeed: 'lower_display_line_now_wind_speed',
  },
  pollen: {
    pollenCategory: 'lower_display_line_pollen_category',
    pollenType: 'lower_display_line_pollen_type',
    pollenScale: 'lower_display_line_pollen_scale',
    productLabel: 'lower_display_line_pollen_product_label',
  },
  todayTonight: {
    precipChance: 'lower_display_line_today_tonight_precip_chance',
    productLabel: 'lower_display_line_today_tonight_product_label',
    snowAccumulation: 'lower_display_line_today_tonight_snow_Accumulation',
    temperature: 'lower_display_line_today_tonight_temperature',
    weatherPhrase: 'lower_display_line_today_tonight_weather_phrase',
  },
  tomorrow: {
    precipChance: 'lower_display_line_tomorrow_precip_chance',
    productLabel: 'lower_display_line_tomorrow_product_label',
    snowAccumulation: 'lower_display_line_tomorrow_snow_Accumulation',
    temperatureHigh: 'lower_display_line_tomorrow_temperature_high',
    temperatureLow: 'lower_display_line_tomorrow_temperature_low',
    weatherPhrase: 'lower_display_line_tomorrow_weather_phrase',
  },
  hourly: {
    productLabel: 'lower_display_line_hourly_product_label',
    temperature: 'lower_display_line_hourly_temperature',
    precipitation: 'lower_display_line_hourly_precipitation',
  },
  sunriseSunsetMoonPhase: {
    sunriseSunsetProductLabel: 'lower_display_line_sunrise_sunset_product_label',
    sunriseTime: 'lower_display_line_sunrise_time',
    sunsetTime: 'lower_display_line_sunset_time',
    moonPhaseProductLabel: 'lower_display_line_moon_phase_product_label',
    moonPhaseValue: 'lower_display_line_moon_phase_value',
  },
  airQuality: {
    productLabel: 'lower_display_line_air_quality_label',
    airQualityIcon: 'lower_display_line_air_quality_icon',
    airQualityDescriptor: 'lower_display_line_air_quality_descriptor',
  },
  twoDay: {
    dayOfWeek: 'lower_display_line_two_day_day_of_week',
    precipChance: 'lower_display_line_two_day_precip_chance',
    productLabel: 'lower_display_line_two_day_product_label',
    temperatureHigh: 'lower_display_line_two_day_temperature_high',
    temperatureLow: 'lower_display_line_two_day_temperature_low',
    weatherPhrase: 'lower_display_line_two_day_weather_phrase',
  },
  threeDay: {
    dayOfWeek: 'lower_display_line_three_day_day_of_week',
    precipChance: 'lower_display_line_three_day_precip_chance',
    productLabel: 'lower_display_line_three_day_product_label',
    temperatureHigh: 'lower_display_line_three_day_temperature_high',
    temperatureLow: 'lower_display_line_three_day_temperature_low',
  },
  severeCrawl: {
    severeCrawlLabel: 'lower_display_line_severe_crawl_label',
    severeCrawlText: 'lower_display_line_severe_crawl_text',
  },
};
